import React from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import Typography from "aldoo-ra/Typography"
import parse from "html-react-parser"

const PWUTrustedCards = () => {
  return (
    <CMSRender
      contentType="PWUTrustedPartnershipSection"
      renderItem={(data, id) => {
        return (
          <div
            key={id}
            className="w-full flex items-center justify-center px-4 md:px-px1_l lg:px-4 xl:px-px1_xl mb-[116px]"
          >
            <div className="w-full xl:max-w-w2_xl mx-auto">
              {/* Title - Centered */}
              <Typography
                component="h2"
                variant="h1"
                className="text-text text-center mb-[95px]"
              >
                {data.title && typeof data.title === "string"
                  ? parse(data.title)
                  : data.title}
              </Typography>

              {/* Stats Cards */}
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-[60px] lg:gap-[20px] xl:gap-[50px]">
                {data.cards?.map((card, index) => (
                  <div
                    key={index}
                    className="w-full max-w-[440px] lg:max-w-[340px] xl:max-w-[350px] flex flex-col items-center  text-center mx-auto"
                  >
                    {/* Circular Image */}
                    <div className="w-[210px] md:w-[300px] lg:w-[192px] aspect-1/1 mx-[80px] mb-[32px]">
                      <img
                        src={card.image}
                        alt={card.title}
                        className="w-full h-full object-cover rounded-full"
                      />
                    </div>

                    {/* Stats Title */}
                    <Typography variant="h3" className="text-text mb-[4px]">
                      {card.title}
                    </Typography>

                    {/* Description */}
                    <Typography variant="body1" className="max-w-[350px]">
                      {card.description}
                    </Typography>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )
      }}
    />
  )
}

export default PWUTrustedCards
